import React, { useState } from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";

const ContactUs = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsLoading(true);
    
    // Simulate form submission
    setTimeout(() => {
      console.log("Form submitted:", formData);
      setIsSubmitted(true);
      setIsLoading(false);
      
      // Reset form after 3 seconds
      setTimeout(() => {
        setIsSubmitted(false);
        setFormData({
          name: "",
          email: "",
          subject: "",
          message: "",
        });
      }, 3000);
    }, 1500);
  };

  // Styles
  const containerStyle = {
    maxWidth: "1200px",
    margin: "0 auto",
    padding: "20px",
    fontFamily: "'Poppins', sans-serif",
    color: "#2d3436",
    backgroundColor: "#ffffff",
    minHeight: "100vh",
  };

  const headerStyle = {
    textAlign: "center",
    padding: "30px 20px",
    background: "linear-gradient(135deg, #0984e3 0%, #74b9ff 100%)",
    borderRadius: "12px",
    marginBottom: "40px",
    color: "white",
    boxShadow: "0 10px 20px rgba(116, 185, 255, 0.3)",
  };

  const titleStyle = {
    fontSize: "clamp(2rem, 5vw, 2.8rem)",
    fontWeight: "700",
    marginBottom: "10px",
    letterSpacing: "0.5px",
  };

  const subtitleStyle = {
    fontSize: "clamp(0.9rem, 2.5vw, 1.2rem)",
    fontWeight: "300",
    opacity: "0.9",
    maxWidth: "700px",
    margin: "0 auto",
    lineHeight: "1.5",
  };

  const contentLayoutStyle = {
    display: "grid",
    gridTemplateColumns: "1fr",
    gap: "30px",
    marginBottom: "40px",
    "@media (min-width: 900px)": {
      gridTemplateColumns: "1fr 1fr",
    },
  };

  const contactInfoStyle = {
    backgroundColor: "#f8f9fa",
    borderRadius: "12px",
    padding: "25px",
    boxShadow: "0 5px 15px rgba(0, 0, 0, 0.08)",
  };

  const formStyle = {
    backgroundColor: "#f8f9fa",
    borderRadius: "12px",
    padding: "25px",
    boxShadow: "0 5px 15px rgba(0, 0, 0, 0.08)",
  };

  const sectionTitleStyle = {
    fontSize: "clamp(1.4rem, 4vw, 1.8rem)",
    fontWeight: "600",
    color: "#2d3436",
    marginBottom: "20px",
    paddingBottom: "10px",
    borderBottom: "2px solid #74b9ff",
  };

  const infoItemStyle = {
    display: "flex",
    alignItems: "flex-start",
    marginBottom: "20px",
    flexDirection: "row",
  };

  const iconStyle = {
    fontSize: "1.5rem",
    marginRight: "15px",
    color: "#0984e3",
    minWidth: "30px",
    flexShrink: "0",
  };

  const infoContentStyle = {
    flex: "1",
  };

  const infoTitleStyle = {
    fontWeight: "600",
    marginBottom: "5px",
    color: "#2d3436",
    fontSize: "1.1rem",
  };

  const infoTextStyle = {
    color: "#636e72",
    margin: "0",
    fontSize: "0.95rem",
    lineHeight: "1.5",
  };

  const formGroupStyle = {
    marginBottom: "20px",
  };

  const labelStyle = {
    display: "block",
    marginBottom: "8px",
    fontWeight: "500",
    color: "#2d3436",
    fontSize: "0.95rem",
  };

  const inputStyle = {
    width: "100%",
    padding: "12px 15px",
    border: "1px solid #ddd",
    borderRadius: "8px",
    fontSize: "1rem",
    transition: "all 0.3s ease",
    boxSizing: "border-box",
    ":focus": {
      outline: "none",
      borderColor: "#0984e3",
      boxShadow: "0 0 0 3px rgba(9, 132, 227, 0.1)",
    },
  };

  const textareaStyle = {
    ...inputStyle,
    minHeight: "120px",
    resize: "vertical",
    fontFamily: "inherit",
  };

  const buttonStyle = {
    backgroundColor: "#0984e3",
    color: "white",
    border: "none",
    borderRadius: "8px",
    padding: "14px 25px",
    fontSize: "1rem",
    fontWeight: "600",
    cursor: "pointer",
    transition: "all 0.3s ease",
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    position: "relative",
    ":hover": {
      backgroundColor: "#0077c2",
      transform: "translateY(-2px)",
    },
    ":disabled": {
      backgroundColor: "#74b9ff",
      cursor: "not-allowed",
      transform: "none",
    },
  };

  const spinnerStyle = {
    border: "2px solid rgba(255, 255, 255, 0.3)",
    borderRadius: "50%",
    borderTop: "2px solid white",
    width: "20px",
    height: "20px",
    animation: "spin 1s linear infinite",
    marginRight: "10px",
  };

  const successMessageStyle = {
    backgroundColor: "#d4edda",
    color: "#155724",
    padding: "15px",
    borderRadius: "8px",
    marginBottom: "20px",
    textAlign: "center",
    fontSize: "0.95rem",
  };

  const faqSectionStyle = {
    backgroundColor: "#f8f9fa",
    borderRadius: "12px",
    padding: "25px",
    marginTop: "40px",
    boxShadow: "0 5px 15px rgba(0, 0, 0, 0.08)",
  };

  const faqItemStyle = {
    marginBottom: "20px",
    borderBottom: "1px solid #eee",
    paddingBottom: "15px",
    ":last-child": {
      borderBottom: "none",
      marginBottom: "0",
      paddingBottom: "0",
    },
  };

  const faqQuestionStyle = {
    fontWeight: "600",
    marginBottom: "8px",
    color: "#2d3436",
    fontSize: "1.1rem",
  };

  const faqAnswerStyle = {
    color: "#636e72",
    margin: "0",
    fontSize: "0.95rem",
    lineHeight: "1.6",
  };

  const mapSectionStyle = {
    marginTop: "40px",
    textAlign: "center",
  };

  const mapPlaceholderStyle = {
    backgroundColor: "#e8f4f8",
    borderRadius: "12px",
    padding: "30px 20px",
    marginTop: "20px",
    color: "#0984e3",
    fontWeight: "500",
    fontSize: "1rem",
  };

  // Inline CSS for animations
  const styleElement = document.createElement('style');
  styleElement.textContent = `
    @keyframes spin {
      0% { transform: rotate(0deg); }
      100% { transform: rotate(360deg); }
    }
    
    input:focus, textarea:focus, select:focus {
      outline: none;
      border-color: #0984e3 !important;
      box-shadow: 0 0 0 3px rgba(9, 132, 227, 0.1) !important;
    }
    
    @media (max-width: 768px) {
      .contact-info-item {
        flex-direction: column;
        align-items: flex-start;
      }
      
      .contact-icon {
        margin-bottom: 10px;
      }
    }
    
    @media (max-width: 900px) {
      .content-layout {
        grid-template-columns: 1fr !important;
      }
    }
  `;
  document.head.appendChild(styleElement);

  return (
    <>
      <Navbar />
      <div style={containerStyle}>
        <div style={headerStyle}>
          <h1 style={titleStyle}>Contact Us</h1>
          <p style={subtitleStyle}>
            We're here to help with any questions about our watches and eyewear. 
            Reach out to us through any of the channels below.
          </p>
        </div>

        <div style={contentLayoutStyle} className="content-layout">
          <div style={contactInfoStyle}>
            <h2 style={sectionTitleStyle}>Get In Touch</h2>

            <div style={infoItemStyle} className="contact-info-item">
              <div style={iconStyle} className="contact-icon">📧</div>
              <div style={infoContentStyle}>
                <h3 style={infoTitleStyle}>Email Us</h3>
                <p style={infoTextStyle}>suryawanshiwatch1918@gmail.com</p>
               
              </div>
            </div>

            <div style={infoItemStyle} className="contact-info-item">
              <div style={iconStyle} className="contact-icon">📞</div>
              <div style={infoContentStyle}>
                <h3 style={infoTitleStyle}>Call Us</h3>
                <p style={infoTextStyle}>
                  Call Us: +91 79729 64344
                </p>
                
              </div>
            </div>


            <div style={infoItemStyle} className="contact-info-item">
              <div style={iconStyle} className="contact-icon">🏢</div>
              <div style={infoContentStyle}>
                <h3 style={infoTitleStyle}>Visit Our Store</h3>
                <p style={infoTextStyle}>Station Road, Near Rajwada</p>
                <p style={infoTextStyle}>Tasgaon 416312, (Sangli)</p>
                <p style={infoTextStyle}>India</p>
              </div>
            </div>

            <div style={infoItemStyle} className="contact-info-item">
              <div style={iconStyle} className="contact-icon">🕒</div>
              <div style={infoContentStyle}>
                <h3 style={infoTitleStyle}>Business Hours</h3>
                <p style={infoTextStyle}>Monday-Friday: 9:00 AM - 8:00 PM</p>
                <p style={infoTextStyle}>Saturday: 10:00 AM - 6:00 PM</p>
                <p style={infoTextStyle}>Sunday: 11:00 AM - 5:00 PM</p>
              </div>
            </div>
          </div>

          <div style={formStyle}>
            <h2 style={sectionTitleStyle}>Send Us a Message</h2>

            {isSubmitted && (
              <div style={successMessageStyle}>
                Thank you for your message! We'll get back to you within 24 hours.
              </div>
            )}

            <form onSubmit={handleSubmit}>
              <div style={formGroupStyle}>
                <label style={labelStyle} htmlFor="name">
                  Full Name *
                </label>
                <input
                  style={inputStyle}
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  placeholder="Your full name"
                />
              </div>

              <div style={formGroupStyle}>
                <label style={labelStyle} htmlFor="email">
                  Email Address *
                </label>
                <input
                  style={inputStyle}
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  placeholder="your.email@example.com"
                />
              </div>

              <div style={formGroupStyle}>
                <label style={labelStyle} htmlFor="subject">
                  Subject *
                </label>
                <select
                  style={inputStyle}
                  id="subject"
                  name="subject"
                  value={formData.subject}
                  onChange={handleChange}
                  required
                >
                  <option value="">Select a subject</option>
                  <option value="product-inquiry">Product Inquiry</option>
                  <option value="prescription-help">Prescription Help</option>
                  <option value="order-support">Order Support</option>
                  <option value="return-exchange">Return & Exchange</option>
                  <option value="warranty">Warranty Claim</option>
                  <option value="other">Other</option>
                </select>
              </div>

              <div style={formGroupStyle}>
                <label style={labelStyle} htmlFor="message">
                  Message *
                </label>
                <textarea
                  style={textareaStyle}
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  required
                  placeholder="How can we help you today?"
                ></textarea>
              </div>

              <button
                type="submit"
                style={buttonStyle}
                disabled={isLoading}
              >
                {isLoading ? (
                  <>
                    <div style={spinnerStyle}></div>
                    Sending...
                  </>
                ) : (
                  "Send Message"
                )}
              </button>
            </form>
          </div>
        </div>

        <div style={mapSectionStyle}>
          <h2 style={sectionTitleStyle}>Our Location</h2>
          <div style={mapPlaceholderStyle}>
            [Interactive Map Would Be Displayed Here]
            <p>Station Road, Near Rajwada, Tasgaon 416312, India</p>
          </div>
        </div>

        <div style={faqSectionStyle}>
          <h2 style={sectionTitleStyle}>Frequently Asked Questions</h2>

          <div style={faqItemStyle}>
            <h3 style={faqQuestionStyle}>
              How long does it take to get a response?
            </h3>
            <p style={faqAnswerStyle}>
              We typically respond to all inquiries within 24 hours during
              business days. For urgent matters, please call us directly.
            </p>
          </div>

          <div style={faqItemStyle}>
            <h3 style={faqQuestionStyle}>
              Do you help with prescription questions?
            </h3>
            <p style={faqAnswerStyle}>
              Yes! Our licensed opticians are available to help you understand
              your prescription and find the perfect frames and lenses for your
              needs.
            </p>
          </div>

          <div style={faqItemStyle}>
            <h3 style={faqQuestionStyle}>
              Can I schedule an eye exam at your location?
            </h3>
            <p style={faqAnswerStyle}>
              Absolutely! Our optical center offers comprehensive eye exams.
              Please call to schedule an appointment.
            </p>
          </div>

          <div style={faqItemStyle}>
            <h3 style={faqQuestionStyle}>
              Do you offer virtual try-on for eyewear?
            </h3>
            <p style={faqAnswerStyle}>
              Yes, we have a virtual try-on feature on our website. If you need
              assistance, our support team can guide you through the process.
            </p>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default ContactUs;